import { PolicyConfigFormValues } from '../../PolicyConfigurationFormSection';

/**
 * Type-specific form data for Kubernetes Registry Policy
 * Represents which namespaces each registry is accessible in
 */
export interface KubernetesRegistryTypeSpecificData {
  accessRows: Array<{
    registryId: number;
    namespaces: string[];
  }>;
}

/**
 * Complete form values for Kubernetes Registry Policy form
 * Includes both common policy config fields and type-specific data
 */
export interface KubernetesRegistryFormValues
  extends PolicyConfigFormValues,
    KubernetesRegistryTypeSpecificData {}

/**
 * API payload for Kubernetes Registry Policy
 * Namespaces only per registry (access is at namespace level, not user/team level)
 */
export interface KubernetesRegistryPolicyPayload {
  RegistryAccessPolicies: Record<
    string,
    {
      Namespaces: Array<{ value: string; enforce: boolean }>;
    }
  >;
}

/**
 * Default initial values for Kubernetes Registry Policy (create mode)
 */
export const KUBERNETES_REGISTRY_INITIAL_VALUES: KubernetesRegistryFormValues =
  {
    name: '',
    environmentGroupIds: [],
    accessRows: [],
  };
